import { render, staticRenderFns } from "./CustomerTransactions.vue?vue&type=template&id=abd6cf8e"
import script from "./CustomerTransactions.vue?vue&type=script&lang=js"
export * from "./CustomerTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports